export default "__VITE_PUBLIC_ASSET__67743a38__"